module.exports = __webpack_public_path__ + "img/honors.b9049442.jpg";